import apiClient from './client'
import type { Suggestion, CreateSuggestionInput, UpdateSuggestionInput } from '@brent/shared/types'

// Re-export types for convenience
export type { Suggestion, CreateSuggestionInput, UpdateSuggestionInput }

/**
 * Get all suggestions for the current user
 */
export const getSuggestions = async (): Promise<Suggestion[]> => {
  const response = await apiClient.get<{ suggestions: Suggestion[] }>('/suggestions')
  return response.suggestions
}

/**
 * Create a new suggestion
 */
export const createSuggestion = async (input: CreateSuggestionInput): Promise<Suggestion> => {
  return apiClient.post<Suggestion>('/suggestions', input)
}

/**
 * Update an existing suggestion
 */
export const updateSuggestion = async (
  id: string,
  input: UpdateSuggestionInput,
): Promise<Suggestion> => {
  return apiClient.put<Suggestion>(`/suggestions/${id}`, input)
}

/**
 * Delete a suggestion
 */
export const deleteSuggestion = async (id: string): Promise<void> => {
  await apiClient.delete(`/suggestions/${id}`)
}
